import { render, staticRenderFns } from "./BhandargharCategories.vue?vue&type=template&id=2d709d8f&"
import script from "./BhandargharCategories.vue?vue&type=script&lang=js&"
export * from "./BhandargharCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports